import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import KeyValueDTO from '../models/generic/KeyValueDTO';

export class GradeApiController {
    // get: Grade/GetAllGrades
    public RouteGetAllGrades = () => `Grade/GetAllGrades`;
    public getAllGrades(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<string, number>[]>> {
        let url = this.RouteGetAllGrades();
        return HttpApi.RestRequest<any, KeyValueDTO<string, number>[]>(null, 'get', url, requestOptions);
    }
}
var service = new GradeApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/GradeApiController.ts